import React from 'react';
import LexChat from './LexChat';

interface RightSidebarProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
}

const RightSidebar: React.FC<RightSidebarProps> = ({
  collapsed,
  onToggleCollapse
}) => {
  return (
    <aside className={`right-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* Chat Content - no header */}
      {!collapsed && (
        <div style={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          overflow: 'hidden',
          padding: '16px 0 0 0'
        }}>
          <LexChat fullScreen={false} />
        </div>
      )}
    </aside>
  );
};

export default RightSidebar;
